"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardRootRouter = void 0;
const core_1 = require("@veeam/core");
class WizardRootRouter extends core_1.Router {
    constructor(interactor, wizardBuilder, viewController) {
        super(interactor);
        this.wizardBuilder = wizardBuilder;
        this.viewController = viewController;
        this.wizard = null;
        this.wizardAttached = false;
        interactor.router = this;
    }
    didLoad() {
        return __awaiter(this, void 0, void 0, function* () {
            this.wizard = yield this.wizardBuilder.build();
            this.viewController.replace(this.wizard.router.viewController);
            yield this.interactable.activate();
            yield this.internalAttachWizard();
        });
    }
    internalAttachWizard() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.wizard && this.wizardAttached) {
                return this.wizard;
            }
            if (!this.wizard) {
                this.wizard = yield this.wizardBuilder.build();
            }
            yield this.attachChild(this.wizard.router);
            return this.wizard;
        });
    }
    updateStepAvailability(patchState) {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            wizard === null || wizard === void 0 ? void 0 : wizard.actionable.updateStepAvailability(patchState);
        });
    }
    updateStepDisableState(patchState) {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            wizard === null || wizard === void 0 ? void 0 : wizard.actionable.updateStepDisableState(patchState);
        });
    }
    getActionsState() {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            return wizard === null || wizard === void 0 ? void 0 : wizard.actionable.getActionsState();
        });
    }
    updateActionsState(patchState) {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            return wizard === null || wizard === void 0 ? void 0 : wizard.actionable.updateActionsState(patchState);
        });
    }
    tryCompleteAllSteps() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            return (_a = wizard === null || wizard === void 0 ? void 0 : wizard.actionable.tryCompleteAllSteps()) !== null && _a !== void 0 ? _a : { ok: true, completedIds: [] };
        });
    }
    switchStepById(stepId) {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            yield (wizard === null || wizard === void 0 ? void 0 : wizard.actionable.switchStepById(stepId));
        });
    }
    startLoading() {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            wizard === null || wizard === void 0 ? void 0 : wizard.actionable.startLoading();
        });
    }
    cancelLoading() {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            wizard === null || wizard === void 0 ? void 0 : wizard.actionable.cancelLoading();
        });
    }
    startPending() {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            wizard === null || wizard === void 0 ? void 0 : wizard.actionable.startPending();
        });
    }
    cancelPending() {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            wizard === null || wizard === void 0 ? void 0 : wizard.actionable.cancelPending();
        });
    }
    getCurrentStepId() {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            return wizard === null || wizard === void 0 ? void 0 : wizard.actionable.getCurrentStepId();
        });
    }
    updateHeaderState(state) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            return (_b = (_a = wizard === null || wizard === void 0 ? void 0 : wizard.actionable) === null || _a === void 0 ? void 0 : _a.updateHeaderState) === null || _b === void 0 ? void 0 : _b.call(_a, state);
        });
    }
    dropStepValidation(stepId) {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            return wizard === null || wizard === void 0 ? void 0 : wizard.actionable.dropStepValidation(stepId);
        });
    }
    dropAllNextStepsValidation(startStepId) {
        return __awaiter(this, void 0, void 0, function* () {
            const wizard = yield this.internalAttachWizard();
            return wizard === null || wizard === void 0 ? void 0 : wizard.actionable.dropAllNextStepsValidation(startStepId);
        });
    }
}
exports.WizardRootRouter = WizardRootRouter;
//# sourceMappingURL=WizardRootRouter.js.map